import {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import ProfileOrders from './ProfileOrders';
import {Order} from '@/types/Order.interface.ts';
import {ProfileMain} from './ProfileMain';
// import { useMultiStorage } from '../../hooks/useStorage';
// import { useLocalStorage } from '../../hooks/useLocalStorage';
import {API_URL} from '../../config.tsx';
import {RootState, useAppSelector} from '@/utils/storage/stores/store.ts';

/**
 * Страница профиля пользователя
 * @returns
 */
export const Profile: React.FC = () => {
    // const  {getStorageValue} = useLocalStorage();
    const [orders, setOrders] = useState<Order[]>([]);
    const {page} = useParams<{ page: string }>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    // const [cartId, setCartId] = useState<number | null>(null);
    const cartId = useAppSelector((state: RootState) => state.user.userInfo?.cartId);
    // const storage = useMultiStorage({
    //   cartId: ['cartId', getStorageValue('cartId')],
    // })[0];

    const getOrders = (page: number = 0, limit: number = 1) => {
        setIsLoading(true);
        fetch(`${API_URL}/user/orders?page=${page}&limit=${limit}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => {
                setOrders(result);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`;
    };

    const getPaymentStatus = (order: Order) => {
        if (order.paymentAmount > 0 && order.remainingPaymentAmount > 0) return `Доплата ${order.remainingPaymentAmount} ₽`;
        else if (order.paymentAmount === 0 && order.remainingPaymentAmount > 0) return 'Не оплачено';
        else if (order.paymentAmount > 0 && order.remainingPaymentAmount === 0) return 'Оплачено';
        return '';
    }

    const copyOrder = (orderId: number) => {
        if (cartId === null || typeof window === 'undefined') return;
        setIsLoading(true);
        fetch(`${API_URL}/cart/${cartId}/create_cart_from_order/${orderId}`, {
            method: 'POST',
            credentials: 'include',
        })
            .then(() => window.document.location = '/cart');
    };

    useEffect(() => {
        if (page === 'orders') {
            getOrders();
        }
    }, [page]);

    if (page === 'orders') return <ProfileOrders
        orders={orders}
        getOrders={getOrders}
        formatDate={formatDate}
        getPaymentStatus={getPaymentStatus}
        copyOrder={copyOrder}
        isLoading={isLoading}
    />;

    return <ProfileMain orders={orders}
                        getOrders={getOrders}
                        formatDate={formatDate}
                        getPaymentStatus={getPaymentStatus}
                        isLoading={isLoading}/>;
};

